import { useState } from "react";
import MarketingHeader from "@/components/MarketingHeader";
import MarketingFooter from "@/components/MarketingFooter";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { CLINIC } from "@/lib/brand";

export default function Contact() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/leads/public", { ...form, source: "website", stage: "new" });
      toast.success("Thanks! We'll reach out within 24 hours.");
      setForm({ name: "", phone: "", email: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Failed to send");
    } finally { setLoading(false); }
  };

  return (
    <div>
      <MarketingHeader />
      <section className="max-w-5xl mx-auto px-5 md:px-10 py-16 md:py-24 grid md:grid-cols-2 gap-12">
        <div>
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[color:var(--muted)] mb-3">Contact</p>
          <h1 className="font-heading text-4xl md:text-5xl font-light tracking-tight mb-5">We'd love to hear from you.</h1>
          <p className="text-[color:var(--muted)] leading-relaxed">
            Whether you have a question about consultations, follow-ups, or our online treatment process,
            please send us a note. We typically reply within one business day.
          </p>
          <div className="mt-10 space-y-3 text-sm">
            <p><strong className="text-[color:var(--ink)]">Address</strong><br /><span className="text-[color:var(--muted)]">{CLINIC.address}</span></p>
            <p><strong className="text-[color:var(--ink)]">Phone</strong><br /><span className="text-[color:var(--muted)]">{CLINIC.phone}</span></p>
            <p><strong className="text-[color:var(--ink)]">Email</strong><br /><span className="text-[color:var(--muted)]">{CLINIC.email}</span></p>
          </div>
        </div>
        <form onSubmit={submit} className="bg-white border border-[color:var(--border)] rounded-2xl p-7 space-y-4" data-testid="contact-form">
          <div>
            <label className="text-xs font-semibold tracking-wider uppercase text-[color:var(--muted)]">Full name</label>
            <Input required value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="mt-2" data-testid="contact-name" />
          </div>
          <div>
            <label className="text-xs font-semibold tracking-wider uppercase text-[color:var(--muted)]">Phone</label>
            <Input required value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} className="mt-2" data-testid="contact-phone" />
          </div>
          <div>
            <label className="text-xs font-semibold tracking-wider uppercase text-[color:var(--muted)]">Email</label>
            <Input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="mt-2" data-testid="contact-email" />
          </div>
          <div>
            <label className="text-xs font-semibold tracking-wider uppercase text-[color:var(--muted)]">Message</label>
            <Textarea required rows={4} value={form.message} onChange={e => setForm({...form, message: e.target.value})} className="mt-2" data-testid="contact-message" />
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-full bg-[color:var(--primary)] hover:bg-[color:var(--primary-hover)] text-white h-11" data-testid="contact-submit">
            {loading ? "Sending…" : "Send message"}
          </Button>
        </form>
      </section>
      <MarketingFooter />
    </div>
  );
}
